/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { LogService, ValidationService } from '../../services';

@Component({
    selector: 'app-validation-messages',
    template: `
        <span
            *ngIf="errorMessage"
            class="validation-message"
            [style.z-index]="zIndex"
            [innerHTML]="errorMessage.toLowerCase() === errorMessage ? (errorMessage | myLbTranslate) : errorMessage">
        </span>
    `,
    styleUrls: ['./validation-messages.component.scss']
})

export class ValidationMessagesComponent {
    /**
     * Form control reference
     */
    @Input() private control: AbstractControl;

    /**
     * Force show validation message
     */
    @Input() private forceShow: boolean;

    /**
     * The z-index from the class variable, this ensures that the top validation message is on top!
     */
    public zIndex: number;

    constructor(
        private logService: LogService,
        private validationService: ValidationService
    ) {
        this.zIndex = validationService.getZIndex();
    }

    /**
     * Get error message from control.
     * @returns {any}
     */
    get errorMessage(): any {
        if (!this.control) {
            this.logService.error('ValidationMessagesComponent:errorMessage', 'Unable to find form control.');
        } else {
            for (const propertyName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(propertyName) && (this.control.touched || this.forceShow)) {
                    const errorMSG = this.validationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
                    if (errorMSG !== undefined) {
                        return errorMSG;
                    } else {
                        // This is here, so we can use the error messages inside the validation.service.ts file
                        // OR use the ones created in the directive itself.
                        if (typeof this.control.getError(propertyName) === 'string') {
                            return this.control.getError(propertyName);
                        }
                    }
                }
            }

            return null;
        }

    }
}
